import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { useIntl } from "react-intl";

export default function AppFooter() {
  const intl = useIntl();
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        py: 2,
        px: 2,
        bgcolor: "#f5f5f5",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Link
        href="https://www.culnou.com/mumu/"
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        variant="caption"
        color="text.secondary"
      >
        {intl.formatMessage({ id: "footer.copyright" })}
      </Link>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Link href="#" underline="hover" variant="caption">
          {intl.formatMessage({ id: "footer.help" })}
        </Link>
        <Link href="#" underline="hover" variant="caption">
          {intl.formatMessage({ id: "footer.terms" })}
        </Link>
      </Box>
    </Box>
  );
}
